























import ripple from "./ripple.vue";
import userIcon from "./userIcon.vue";
import gbutton from "./button.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import {frontendClient} from "../lib/client";

@Component({
    components: {
        ripple,
        userIcon,
        gbutton
    }
})
export default class Checkbox extends Vue {
    @Prop({}) visible:boolean;

    userDetails = frontendClient.userData;

    async logout(){
        frontendClient.logOut().then(() => {
            location.reload();
        }).catch(() => {
            frontendClient.giveError("ERROR LOGGING OUT");
        });
    }

    passwordEdit(){
        this.$emit('editPrompt',{instance:'password',object:null});
    }
}

